import { ca } from '@cian/analytics';

import { IProduct, getPageNumber } from '../../utils/trackings';
import { TUser } from '../../api';
import { IPageState } from '../../types/page';

export function trackFavoriteRemove(
  pageData: IPageState,
  user: TUser,
  label: string,
  product: IProduct,
  total: number,
) {
  ca('eventEbc', {
    name: 'oldevent',
    category: 'favorite',
    action: 'remove_from_favorites',
    label,
    user: {
      abGroup: pageData.abGroup,
      isAuthorized: user.isAuthenticated,
      userId: user.isAuthenticated ? user.userId : undefined,
    },
    page: {
      listingType: 'list',
      sortType: 'default',
      pageNumber: getPageNumber(total, product.position),
      offersQty: total,
      pageType: 'ListingFavorites',
      siteType: pageData.deviceType === 'phone' ? 'mobile' : pageData.deviceType,
    },
    products: [product],
  });
}
